import React, { useEffect, useState, useRef } from 'react';
import { Box, Typography, Paper, TextField, Button, Alert, MenuItem, Checkbox, FormControlLabel, Chip, Switch, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import API, { getApiKeys, saveApiKey } from '../api';

// [МЕДІА АВАТАР] Дашборд-панель: логотип + перемикач моделей + токени + upload + Generate.
const MODELS = [
  { key: 'p-video-avatar', label: 'p-video-avatar (Replicate)', note: 'дешево + хороша якість · ~$3 / відео 2хв', platform: 'replicate' },
  { key: 'hunyuan-avatar', label: 'Hunyuan-Avatar (WaveSpeed)', note: 'топ-якість, дешевше за OmniHuman · ~$3.6-7.2 / 2хв · (скоро)', platform: 'wavespeed' },
  { key: 'sadtalker', label: 'SadTalker (Replicate)', note: 'найдешевше, базова якість · ~$0.07/ран', platform: 'replicate' },
  { key: 'omnihuman-1.5', label: 'OmniHuman 1.5 (Replicate)', note: 'топ-якість + емоції, ДОРОГО · ~$14-19 / 2хв', platform: 'replicate' },
  { key: 'hedra-character-3', label: 'Hedra Character-3', note: 'преміум talking-head, реалізм · ~$2/хв · потребує Hedra-ключ', platform: 'hedra' },
];
const ALLOWED_IMG = /\.(jpe?g|png|webp)$/i;
const ALLOWED_AUD = /\.(mp3|wav|m4a|ogg)$/i;
const FMT_TEXT = 'Фото: JPG / PNG / WEBP · Аудіо: MP3 / WAV / M4A / OGG';

export default function AvatarPage() {
  const [keys, setKeys] = useState([]);
  // [D-301] фонова музика Хаба
  const [hubMusic, setHubMusic] = useState([]);
  const [musicUploading, setMusicUploading] = useState(false);
  const musicInputRef = useRef(null);
  // [AVA-PRICING] Управління цінами
  const [pricing, setPricing] = useState([]);
  const [pricingEdit, setPricingEdit] = useState({});
  const [pricingSaving, setPricingSaving] = useState({});
  const [pricingMsg, setPricingMsg] = useState('');
  const DURATIONS = [10, 30, 60, 120];
  const loadPricing = () => API.get('/avatar/pricing/admin')
    .then(r => { setPricing(r.data.tiers || []); setPricingEdit({}); }).catch(() => {});
  useEffect(() => { loadPricing(); }, []);
  const saveTier = async (tier) => {
    const price = parseFloat(pricingEdit[tier.quality_key + '_price'] ?? tier.price_per_10s);
    const cost = parseFloat(pricingEdit[tier.quality_key + '_cost'] ?? tier.cost_per_10s);
    if (isNaN(price) || price < 0) { setPricingMsg('❌ Невірна ціна'); return; }
    setPricingSaving(s => ({ ...s, [tier.quality_key]: true }));
    try {
      const fd = new FormData();
      fd.append('quality_key', tier.quality_key);
      fd.append('price_per_10s', price);
      fd.append('cost_per_10s', isNaN(cost) ? tier.cost_per_10s : cost);
      await API.post('/avatar/pricing/update', fd);
      setPricingMsg('✅ Збережено: ' + tier.quality_label);
      loadPricing();
    } catch (e) { setPricingMsg('❌ Помилка збереження'); }
    finally { setPricingSaving(s => ({ ...s, [tier.quality_key]: false })); }
  };

  const loadHubMusic = () => API.get('/hub-music').then(r => setHubMusic(r.data || [])).catch(() => {});
  const uploadHubMusic = async (e) => {
    const f = e.target.files && e.target.files[0]; if (!f) return;
    setMusicUploading(true);
    try { const fd = new FormData(); fd.append('file', f); await API.post('/hub-music/upload', fd); loadHubMusic(); }
    catch (err) { alert('❌ ' + (err.response?.data?.detail || 'помилка завантаження')); }
    finally { setMusicUploading(false); if (musicInputRef.current) musicInputRef.current.value = ''; }
  };
  const toggleHubMusic = async (id) => { try { await API.post('/hub-music/' + id + '/toggle'); loadHubMusic(); } catch (e) {} };
  const deleteHubMusic = async (id) => { try { await API.delete('/hub-music/' + id); loadHubMusic(); } catch (e) {} };
  // [D-298] Model Radar — live-скан новинок генерації
  const [radar, setRadar] = useState(null);
  const [radarAt, setRadarAt] = useState(null);
  const [radarRunning, setRadarRunning] = useState(false);
  const [radarMsg, setRadarMsg] = useState('');
  const radarTimer = useRef(null);
  const loadRadar = () => API.get('/avatar/model-radar').then(r => {
    setRadar(r.data.latest); setRadarAt(r.data.scanned_at); setRadarRunning(!!r.data.running);
    if (!r.data.running && radarTimer.current) { clearInterval(radarTimer.current); radarTimer.current = null; }
  }).catch(() => {});
  const startRadar = async () => {
    setRadarMsg('');
    try {
      const r = await API.post('/avatar/model-radar/refresh', {});
      if (r.data.started) {
        setRadarRunning(true);
        if (!radarTimer.current) radarTimer.current = setInterval(loadRadar, 6000);
      } else if (r.data.reason === 'cooldown') {
        setRadarMsg(`⏳ Кулдаун: зачекай ${Math.ceil((r.data.wait_sec || 0) / 60)} хв (захист від зайвих витрат)`);
      } else if (r.data.reason === 'already_running') {
        setRadarRunning(true);
        if (!radarTimer.current) radarTimer.current = setInterval(loadRadar, 6000);
      }
    } catch (e) { setRadarMsg('❌ ' + (e.response?.data?.detail || 'помилка запуску')); }
  };
  useEffect(() => { loadRadar(); return () => { if (radarTimer.current) clearInterval(radarTimer.current); }; }, []);
  // ── Фаза 3: черга апруву liveness-верифікації облич ──
  const [vpend, setVpend] = useState([]);
  const [vsel, setVsel] = useState({});
  const [vbusy, setVbusy] = useState(0);
  const [vappr, setVappr] = useState([]);
  const [vapprOpen, setVapprOpen] = useState(false);
  const loadVerify = () => API.get('/media/avatar/verify/pending').then(r => setVpend((r.data && r.data.items) || [])).catch(() => {});
  const loadApproved = () => API.get('/media/avatar/verify/approved').then(r => setVappr((r.data && r.data.items) || [])).catch(() => {});
  const deleteVerify = (id, label) => { if (!window.confirm('Видалити верифікацію «' + (label || '') + '»? Відео-доказ і обличчя буде стерто, і юзер більше не зможе генерувати з цим обличчям.')) return; API.delete('/media/avatar/verify/' + id).then(() => { loadApproved(); loadVerify(); }).catch(() => {}); };
  const [vcust, setVcust] = useState([]);
  const loadCustom = () => API.get('/media/avatar/verify/custom-pending').then(r => setVcust((r.data && r.data.items) || [])).catch(() => {});
  useEffect(() => { loadCustom(); const t = setInterval(loadCustom, 20000); return () => clearInterval(t); }, []);
  const custApprove = (id) => { setVbusy(id); API.post('/media/avatar/verify/' + id + '/photo-approve').then(() => { loadCustom(); loadApproved(); }).catch(() => {}).finally(() => setVbusy(0)); };
  const custReject = (id) => { setVbusy(id); API.post('/media/avatar/verify/' + id + '/photo-reject').then(() => loadCustom()).catch(() => {}).finally(() => setVbusy(0)); };
  useEffect(() => { loadVerify(); loadApproved(); const t = setInterval(() => { loadVerify(); loadApproved(); }, 20000); return () => clearInterval(t); }, []);
  const approveVerify = (id) => { setVbusy(id); API.post('/media/avatar/verify/' + id + '/approve', { frame_index: vsel[id] || 0 }).then(() => loadVerify()).catch(() => {}).finally(() => setVbusy(0)); };
  const rejectVerify = (id) => { const reason = window.prompt('Причина відхилення (необовʼязково):'); if (reason === null) return; setVbusy(id); API.post('/media/avatar/verify/' + id + '/reject', { reason }).then(() => loadVerify()).catch(() => {}).finally(() => setVbusy(0)); };
  const [model, setModel] = useState('p-video-avatar');
  const [replicate, setReplicate] = useState('');
  const [wavespeed, setWavespeed] = useState('');
  const [hedra, setHedra] = useState('');
  const [photo, setPhoto] = useState(null);
  const [photoUrl, setPhotoUrl] = useState('');
  const [audio, setAudio] = useState(null);
  const [audioUrl, setAudioUrl] = useState('');
  const [inVideo, setInVideo] = useState(null);
  const [inVideoUrl, setInVideoUrl] = useState('');
  const [duration, setDuration] = useState(0);
  const [prompt, setPrompt] = useState('');
  const [text, setText] = useState('');
  const [ttsLang, setTtsLang] = useState('uk');
  const [translate, setTranslate] = useState(true);
  const [multilang, setMultilang] = useState(false);
  const [msg, setMsg] = useState('');
  const [ccFile, setCcFile] = useState(null);
  const [ccUploading, setCcUploading] = useState(false);
  const [ccPath, setCcPath] = useState('');
  const [ccCopied, setCcCopied] = useState(false);
  const [busy, setBusy] = useState(false);
  const [video, setVideo] = useState('');

  const [emotionUi, setEmotionUi] = useState(false)
  const [emotionBusy, setEmotionBusy] = useState(false)
  const [limUsers, setLimUsers] = useState([])
  const [limDefaults, setLimDefaults] = useState({max_img_mb:5,max_aud_mb:10,max_vid_mb:100,daily_gen_limit:null})
  const [limEdit, setLimEdit] = useState(null)  // {tg_id, username, max_img_mb, max_aud_mb, max_vid_mb, daily_gen_limit, note}
  const [limMsg, setLimMsg] = useState(null)
  const [newTgId, setNewTgId] = useState("")
  const [avStats, setAvStats] = useState(null)
  const [userRevenues, setUserRevenues] = useState([])
  const [avaUsers, setAvaUsers] = useState([])
  const [avaNewIds, setAvaNewIds] = useState(null);
  // 🎁 2026-09-11: подарунок балансу (у USDT — саме ним оплачуються генерації)
  const [avaGift, setAvaGift] = useState(null);      // юзер, якому даруємо
  const [avaGiftAmt, setAvaGiftAmt] = useState('3');
  const [avaGiftNotify, setAvaGiftNotify] = useState(true);
  const [avaGiftMsg, setAvaGiftMsg] = useState('');
  const [avaGiftBusy, setAvaGiftBusy] = useState(false);
  const avaGiftGo = async () => {
    const amt = Number(avaGiftAmt);
    if (!amt) { setAvaGiftMsg('❌ Вкажи суму'); return; }
    setAvaGiftBusy(true); setAvaGiftMsg('…');
    try {
      const r = await API.post('/avatar/user-balance-grant', { tg_id: avaGift.tg_id, amount_usdt: amt, notify: avaGiftNotify });
      const d = r.data || {};
      let m = (amt > 0 ? '✅ Подаровано $' + amt.toFixed(2) : '✅ Знято $' + (-amt).toFixed(2)) + ' · баланс: $' + Number(d.balance_usdt || 0).toFixed(2);
      if (amt > 0 && avaGiftNotify) {
        m += d.notified
          ? ' · вітання надіслано' + (d.notify_how === 'photo' ? ' 🖼' : ' (текстом)') + (d.notify_effect ? ' 🎉' : '')
          : ' · ⚠️ вітання НЕ дійшло: ' + (d.notify_error || 'невідома причина');
      } else if (amt > 0) m += ' · без вітання';
      setAvaGiftMsg(m);
      loadStats();
    } catch (e) { setAvaGiftMsg('❌ ' + (e?.response?.data?.detail || e.message)); }
    setAvaGiftBusy(false);
  };
  const [pendingVideos, setPendingVideos] = useState([])
  const [videoFeatureSaving, setVideoFeatureSaving] = useState({})
  const [rejectReason, setRejectReason] = useState({})
  const [repBalance, setRepBalance] = useState(null)
  const [repTopupInput, setRepTopupInput] = useState('')
  const [repTopupSaving, setRepTopupSaving] = useState(false)

  // Logo state
  const [logoUrl, setLogoUrl] = useState('');
  const [logoFile, setLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState('');
  const [logoMsg, setLogoMsg] = useState('');
  const [logoBusy, setLogoBusy] = useState(false);
  const logoInputRef = useRef();

  const load = () => getApiKeys().then(r => setKeys(r.data || [])).catch(() => {});
  const loadLogo = () => API.get('/media/avatar/logo').then(r => { if (r.data.logo_url) setLogoUrl(r.data.logo_url); }).catch(() => {});
  const loadEmotionUi = () => API.get('/miniapp/avatar/config').then(r => { if (r.data.emotion_ui !== undefined) setEmotionUi(r.data.emotion_ui) }).catch(() => {});
  const loadLimits = () => API.get('/miniapp/avatar/user-limits').then(r => { setLimUsers(r.data.users || []); setLimDefaults(r.data.defaults || limDefaults); }).catch(() => {});
  const loadStats = () => { API.get('/avatar/stats').then(r => setAvStats(r.data)).catch(() => {}); API.get('/avatar/user-revenues').then(r => setUserRevenues(r.data.users || [])).catch(() => {}); API.get('/avatar/users-list').then(r => {
    const _list = r.data.users || [];
    setAvaUsers(_list);
    // 🤖 2026-09-11: 🆕 фіксуємо на ПЕРШОМУ завантаженні, далі «прочитано» їх не гасить
    setAvaNewIds(prev => prev || new Set(_list.filter(u => u.is_new).map(u => u.tg_id)));
    // позначку шлемо ПІСЛЯ відповіді — інакше сервер міг би вже не віддати is_new
    API.post('/avatar/users/mark-new-seen').catch(() => {});
  }).catch(() => {}); API.get('/avatar/pending-videos').then(r => setPendingVideos(r.data.videos || [])).catch(() => {}); API.get('/avatar/replicate-balance').then(r => { setRepBalance(r.data); setRepTopupInput(String(r.data.topup || '')); }).catch(() => {}); };
  useEffect(() => { load(); loadLogo(); loadEmotionUi(); loadLimits(); loadHubMusic(); loadStats(); }, []);
  const masked = (svc) => { const k = keys.find(x => x.service === svc); return k && k.masked ? k.masked : ''; };

  const saveKey = async (svc, val, clear) => {
    if (!val.trim()) { setMsg('❌ Спершу встав токен'); return; }
    try { await saveApiKey(svc, val.trim()); setMsg('✅ Збережено: ' + svc); clear(''); load(); }
    catch { setMsg('❌ Помилка збереження'); }
  };

  const onLogoFile = (e) => {
    const f = e.target.files[0]; if (!f) return;
    if (!ALLOWED_IMG.test(f.name)) { setLogoMsg('❌ Дозволено: JPG, PNG, WEBP'); return; }
    setLogoFile(f); setLogoPreview(URL.createObjectURL(f)); setLogoMsg('');
  };
  const saveLogo = async () => {
    if (!logoFile) { setLogoMsg('❌ Спершу вибери файл'); return; }
    setLogoBusy(true); setLogoMsg('⏳ Завантажую…');
    try {
      const fd = new FormData(); fd.append('file', logoFile);
      const r = await API.post('/media/avatar/logo/upload', fd);
      setLogoUrl(r.data.logo_url + '?v=' + Date.now());
      setLogoFile(null); setLogoPreview('');
      setLogoMsg('✅ Логотип збережено і оновлено у Hub Apps!');
    } catch (e) {
      setLogoMsg('❌ ' + ((e.response && e.response.data && e.response.data.detail) || 'Помилка завантаження'));
    } finally { setLogoBusy(false); }
  };

  const onPhoto = (e) => {
    const f = e.target.files[0]; if (!f) return;
    if (!ALLOWED_IMG.test(f.name)) { setMsg('❌ Фото невірного формату. Дозволено: JPG/PNG/WEBP'); return; }
    setPhoto(f); setPhotoUrl(URL.createObjectURL(f)); setMsg('');
  };
  const onAudio = (e) => {
    const f = e.target.files[0]; if (!f) return;
    if (!ALLOWED_AUD.test(f.name)) { setMsg('❌ Аудіо невірного формату. Дозволено: MP3/WAV/M4A/OGG'); return; }
    setAudio(f); setAudioUrl(URL.createObjectURL(f)); setMsg('');
  };
  const onVideo = (e) => {
    const f = e.target.files[0]; if (!f) return;
    if (!/\.(mp4|mov|webm|m4v)$/i.test(f.name)) { setMsg('❌ Відео: лише MP4/MOV/WEBM'); return; }
    setInVideo(f); setInVideoUrl(URL.createObjectURL(f)); setMsg('');
  };

  const sel = MODELS.find(m => m.key === model) || MODELS[0];
  const generate = async () => {
    if (!inVideo && (!photo || !audio)) { setMsg('❌ Дай ВІДЕО, або фото+аудіо'); return; }
    setBusy(true); setVideo(''); setMsg('⏳ Стартую генерацію…');
    try {
      const fd = new FormData();
      fd.append('model_key', model);
      if (inVideo) { fd.append('video', inVideo); }
      else { fd.append('image', photo); fd.append('audio', audio); }
      if (duration > 0) fd.append('duration', String(duration));
      if (prompt.trim()) fd.append('prompt', prompt.trim());
      if (text.trim()) { fd.append('text', text.trim()); fd.append('tts_lang', ttsLang); fd.append('translate', translate ? 'true' : 'false'); fd.append('multilang', multilang ? 'true' : 'false'); }
      const r = await API.post('/media/avatar/generate', fd, { timeout: 120000 });
      if (r.data.video_url) { setVideo(r.data.video_url); setMsg('✅ Готово! Відео нижче.'); return; }
      const jobId = r.data.job_id;
      if (!jobId) throw new Error('no job id');
      setMsg('⏳ Обробка на сервері… (аватар + озвучка, 1–3 хв; не закривай вкладку)');
      const started = Date.now();
      while (Date.now() - started < 600000) {
        await new Promise(res => setTimeout(res, 4000));
        let sres;
        try { sres = await API.get('/media/avatar/result/' + jobId, { timeout: 30000 }); }
        catch (er) { continue; }
        const st = sres.data.status;
        if (st === 'done') { setVideo(sres.data.video_url); setMsg('✅ Готово! Відео нижче.'); return; }
        if (st === 'error') { setMsg('❌ ' + (sres.data.error || 'Помилка генерації')); return; }
        setMsg('⏳ Обробка… ' + Math.round((Date.now() - started) / 1000) + 'с (зачекай, кілька моделей по черзі)');
      }
      setMsg('❌ Час вийшов (10 хв). Спробуй ще раз або коротший текст/відео.');
    } catch (e) {
      setMsg('❌ ' + ((e.response && e.response.data && e.response.data.detail) || 'Помилка генерації'));
    } finally { setBusy(false); }
  };

  const fieldSx = { input: { color: '#fff' }, textarea: { color: '#fff' }, '& .MuiOutlinedInput-notchedOutline': { borderColor: '#333' }, '& .MuiSelect-select': { color: '#fff' } };


  const uploadForClaude = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setCcFile(file.name);
    setCcUploading(true);
    setCcPath('');
    try {
      const fd = new FormData();
      fd.append('file', file);
      // [D-761] вхід OWNER у дашборд (API додає його сам), без вшитого токена
      const { data } = await API.post('/miniapp/claude-upload', fd);
      if (data && data.ok) {
        setCcPath(data.path);
      } else {
        setCcPath('Помилка: ' + ((data && data.detail) || 'невідома'));
      }
    } catch(err) {
      setCcPath('Помилка: ' + ((err.response && err.response.data && err.response.data.detail) || err.message));
    }
    setCcUploading(false);
  };

  const copyCcPath = () => {
    navigator.clipboard.writeText('прочитай ' + ccPath).then(() => {
      setCcCopied(true);
      setTimeout(() => setCcCopied(false), 2000);
    });
  };

  return (
    <Box sx={{ p: 3, maxWidth: 820 }}>
      <Typography variant="h4" sx={{ color: '#fff', mb: 1 }}>🤖 Аватар</Typography>
      <Typography sx={{ color: '#aaa', mb: 3 }}>
        AI-аватар: фото + аудіо → говоряче відео. Перемикай модель (як Claude/GPT), зберігай токени, завантажуй фото/аудіо й генеруй.
      </Typography>

      {/* ─── БАЛАНС REPLICATE ─── */}
      <Paper sx={{ p: 2.5, bgcolor: '#0d1117', border: '1px solid rgba(139,92,246,.35)', mb: 3, borderRadius: 2 }}>
        <Typography sx={{ color: '#94a3b8', fontSize: 11, letterSpacing: 1, textTransform: 'uppercase', mb: 2 }}>🔮 Баланс Replicate</Typography>
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', mb: 2 }}>
          <Box sx={{ flex: 1, minWidth: 100, textAlign: 'center', p: 1.5, bgcolor: 'rgba(139,92,246,.1)', borderRadius: 1.5, border: '1px solid rgba(139,92,246,.25)' }}>
            <Typography sx={{ fontSize: 24, fontWeight: 800, color: 'var(--ac2, #a78bfa)', lineHeight: 1 }}>${repBalance ? repBalance.topup.toFixed(2) : '—'}</Typography>
            <Typography sx={{ fontSize: 11, color: '#64748b', mt: 0.5 }}>Поповнено</Typography>
          </Box>
          <Box sx={{ flex: 1, minWidth: 100, textAlign: 'center', p: 1.5, bgcolor: 'rgba(248,113,113,.07)', borderRadius: 1.5, border: '1px solid rgba(248,113,113,.2)' }}>
            <Typography sx={{ fontSize: 24, fontWeight: 800, color: '#f87171', lineHeight: 1 }}>${repBalance ? repBalance.spent.toFixed(2) : '—'}</Typography>
            <Typography sx={{ fontSize: 11, color: '#64748b', mt: 0.5 }}>Витрачено</Typography>
          </Box>
          <Box sx={{ flex: 1, minWidth: 100, textAlign: 'center', p: 1.5,
            bgcolor: repBalance && repBalance.remaining < 0 ? 'rgba(248,113,113,.1)' : repBalance && repBalance.remaining < 2 ? 'rgba(251,191,36,.07)' : 'rgba(52,211,153,.07)',
            borderRadius: 1.5,
            border: repBalance && repBalance.remaining < 0 ? '1px solid rgba(248,113,113,.3)' : repBalance && repBalance.remaining < 2 ? '1px solid rgba(251,191,36,.3)' : '1px solid rgba(52,211,153,.2)' }}>
            <Typography sx={{ fontSize: 24, fontWeight: 800, lineHeight: 1,
              color: repBalance && repBalance.remaining < 0 ? '#f87171' : repBalance && repBalance.remaining < 2 ? '#fbbf24' : '#34d399' }}>
              ${repBalance ? repBalance.remaining.toFixed(2) : '—'}
            </Typography>
            <Typography sx={{ fontSize: 11, color: '#64748b', mt: 0.5 }}>Залишок</Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
          <input
            type="number" step="0.01" min="0" placeholder="Введи суму поповнення ($)"
            value={repTopupInput}
            onChange={e => setRepTopupInput(e.target.value)}
            style={{ flex: 1, background: '#1a1f2e', border: '1px solid rgba(139,92,246,.4)', borderRadius: 8, padding: '8px 12px', color: '#e2e8f0', fontSize: 14, outline: 'none' }}
          />
          <Button variant="contained" disabled={repTopupSaving}
            onClick={async () => {
              const amt = parseFloat(repTopupInput);
              if (isNaN(amt) || amt < 0) return;
              setRepTopupSaving(true);
              const fd = new FormData(); fd.append('amount', String(amt));
              await API.post('/avatar/replicate-topup', fd).catch(() => {});
              await loadStats();
              setRepTopupSaving(false);
            }}
            sx={{ bgcolor: '#7c3aed', '&:hover': { bgcolor: '#6d28d9' }, whiteSpace: 'nowrap', minWidth: 80, fontSize: 12 }}>
            {repTopupSaving ? '...' : 'Зберегти'}
          </Button>
        </Box>
        <Typography sx={{ fontSize: 10, color: '#475569', mt: 1 }}>
          Залишок = поповнення − витрати з ava_gen_log. Точний рахунок: replicate.com/account/billing
        </Typography>
      </Paper>

      {/* ─── ФІНАНСОВА СТАТИСТИКА ─── */}
      {avStats && (
        <Paper sx={{ p: 2.5, bgcolor: '#0d1117', border: '1px solid rgba(52,211,153,.35)', mb: 3, borderRadius: 2 }}>
          <Typography sx={{ color: '#94a3b8', fontSize: 11, letterSpacing: 1, textTransform: 'uppercase', mb: 2 }}>💹 Фінансова статистика</Typography>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            <Box sx={{ flex: 1, minWidth: 120, textAlign: 'center', p: 1.5, bgcolor: 'rgba(52,211,153,.07)', borderRadius: 1.5, border: '1px solid rgba(52,211,153,.2)' }}>
              <Typography sx={{ fontSize: 28, fontWeight: 800, color: '#34d399', lineHeight: 1 }}>${avStats.total_revenue.toFixed(2)}</Typography>
              <Typography sx={{ fontSize: 11, color: '#64748b', mt: 0.5 }}>Дохід (від юзерів)</Typography>
            </Box>
            <Box sx={{ flex: 1, minWidth: 120, textAlign: 'center', p: 1.5, bgcolor: 'rgba(248,113,113,.07)', borderRadius: 1.5, border: '1px solid rgba(248,113,113,.2)' }}>
              <Typography sx={{ fontSize: 28, fontWeight: 800, color: '#f87171', lineHeight: 1 }}>${avStats.total_cost.toFixed(2)}</Typography>
              <Typography sx={{ fontSize: 11, color: '#64748b', mt: 0.5 }}>Витрати (Replicate)</Typography>
            </Box>
            <Box sx={{ flex: 1, minWidth: 120, textAlign: 'center', p: 1.5, bgcolor: 'rgba(251,191,36,.07)', borderRadius: 1.5, border: '1px solid rgba(251,191,36,.25)' }}>
              <Typography sx={{ fontSize: 28, fontWeight: 800, color: '#fbbf24', lineHeight: 1 }}>${avStats.total_profit.toFixed(2)}</Typography>
              <Typography sx={{ fontSize: 11, color: '#64748b', mt: 0.5 }}>Наш прибуток</Typography>
            </Box>
            <Box sx={{ flex: 1, minWidth: 120, textAlign: 'center', p: 1.5, bgcolor: 'rgba(147,197,253,.07)', borderRadius: 1.5, border: '1px solid rgba(147,197,253,.2)' }}>
              <Typography sx={{ fontSize: 28, fontWeight: 800, color: '#93c5fd', lineHeight: 1 }}>{avStats.total_gens}</Typography>
              <Typography sx={{ fontSize: 11, color: '#64748b', mt: 0.5 }}>Генерацій</Typography>
            </Box>
          </Box>
        </Paper>
      )}

      {/* ─── ЮЗЕРИ АВАТАРА ─── */}
      <Paper sx={{ p: 2.5, bgcolor: '#0d1117', border: '1px solid rgba(147,197,253,.25)', mb: 3, borderRadius: 2 }}>
        <Typography sx={{ color: '#94a3b8', fontSize: 11, letterSpacing: 1, textTransform: 'uppercase', mb: 2 }}>👥 Юзери Аватара ({avaUsers.length}){avaNewIds && avaNewIds.size > 0 && <Box component="span" sx={{ ml: 1, color: '#ff8a80', fontWeight: 700 }}>🆕 {avaNewIds.size} нових</Box>}</Typography>
        {avaUsers.length === 0 ? (
          <Typography sx={{ color: '#475569', fontSize: 12 }}>Ще немає юзерів</Typography>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            <Box sx={{ display: 'flex', gap: 1, px: 1, pb: 0.5, borderBottom: '1px solid rgba(255,255,255,.06)' }}>
              {['tg_id','username','баланс','дохід','прибуток','генерацій','📹 відео'].map(h => (
                <Typography key={h} sx={{ color: '#475569', fontSize: 10, textTransform: 'uppercase', flex: h==='tg_id'?1.2:1, minWidth: 0 }}>{h}</Typography>
              ))}
            </Box>
            {avaUsers.map(u => (
              <Box key={u.tg_id} sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 1, py: '5px', borderRadius: 1, bgcolor: (avaNewIds && avaNewIds.has(u.tg_id)) ? 'rgba(255,45,45,.12)' : 'rgba(255,255,255,.02)', '&:hover': { bgcolor: 'rgba(255,255,255,.05)' } }}>
                <Typography sx={{ color: (avaNewIds && avaNewIds.has(u.tg_id)) ? '#ff9a9a' : '#64748b', fontSize: 11, fontFamily: 'monospace', flex: 1.2, minWidth: 0 }}>{(avaNewIds && avaNewIds.has(u.tg_id)) ? '🆕 ' : ''}{u.tg_id}</Typography>
                <Typography sx={{ color: '#cbd5e1', fontSize: 12, fontWeight: 500, flex: 1, minWidth: 0 }}>{u.username || '—'}</Typography>
                <Typography sx={{ color: '#7dd3fc', fontSize: 12, fontWeight: 700, flex: 1, minWidth: 0 }}>${u.balance_usdt.toFixed(2)}</Typography>
                <Typography sx={{ color: '#34d399', fontSize: 12, fontWeight: 700, flex: 1, minWidth: 0 }}>{u.total_revenue > 0 ? '$'+u.total_revenue.toFixed(2) : '—'}</Typography>
                <Typography sx={{ color: u.total_profit > 0 ? '#fbbf24' : '#475569', fontSize: 12, fontWeight: 700, flex: 1, minWidth: 0 }}>{u.total_profit > 0 ? '$'+u.total_profit.toFixed(2) : '—'}</Typography>
                <Typography sx={{ color: '#94a3b8', fontSize: 12, flex: 1, minWidth: 0 }}>{u.gen_count > 0 ? u.gen_count : '—'}</Typography>
                <Button size="small" title="Подарувати баланс"
                  onClick={() => { setAvaGift(u); setAvaGiftAmt('3'); setAvaGiftMsg(''); }}
                  sx={{ fontSize: 10, minWidth: 0, px: 1.2, py: '3px', color: '#fbbf24', border: '1px solid #fbbf2455', borderRadius: 1, whiteSpace: 'nowrap', mr: .5 }}>
                  🎁
                </Button>
                <Button size="small"
                  title={u.video_upload_enabled ? 'Вимкнути завантаження відео' : 'Дозволити завантажувати відео (обличчя+голос)'}
                  disabled={videoFeatureSaving[u.tg_id]}
                  onClick={async () => {
                    setVideoFeatureSaving(s => ({...s, [u.tg_id]: true}));
                    const fd = new FormData();
                    fd.append('tg_id', u.tg_id);
                    fd.append('enabled', String(!u.video_upload_enabled));
                    await API.post('/avatar/user-video-feature', fd).catch(() => {});
                    setVideoFeatureSaving(s => ({...s, [u.tg_id]: false}));
                    loadStats();
                  }}
                  sx={{ fontSize: 10, minWidth: 0, px: 1.2, py: '3px', color: u.video_upload_enabled ? '#34d399' : '#64748b', border: '1px solid', borderColor: u.video_upload_enabled ? '#34d39966' : '#334155', borderRadius: 1, whiteSpace: 'nowrap', bgcolor: u.video_upload_enabled ? 'rgba(52,211,153,.08)' : 'transparent' }}>
                  {videoFeatureSaving[u.tg_id] ? '...' : u.video_upload_enabled ? '✅ Відео ON' : '📹 Дозволити'}
                </Button>
              </Box>
            ))}
          </Box>
        )}
      </Paper>

      {/* ─── ВІДЕО НА ПЕРЕВІРЦІ ─── */}
      {pendingVideos.length > 0 && (
        <Paper sx={{ p: 2.5, bgcolor: '#0d1117', border: '1px solid rgba(251,191,36,.4)', mb: 3, borderRadius: 2 }}>
          <Typography sx={{ color: '#fbbf24', fontSize: 11, letterSpacing: 1, textTransform: 'uppercase', mb: 2 }}>📹 Відео на перевірці ({pendingVideos.filter(v=>v.status==='pending').length})</Typography>
          {pendingVideos.map(v => (
            <Box key={v.id} sx={{ p: 1.5, mb: 1, borderRadius: 1.5, bgcolor: 'rgba(255,255,255,.03)', border: '1px solid', borderColor: v.status==='pending'?'rgba(251,191,36,.3)':v.status==='approved'?'rgba(52,211,153,.3)':'rgba(248,113,113,.3)' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                <Typography sx={{ color: '#94a3b8', fontSize: 11, fontFamily: 'monospace' }}>{v.tg_id}</Typography>
                <Typography sx={{ color: '#cbd5e1', fontSize: 12, fontWeight: 600 }}>{v.username || '—'}</Typography>
                <Typography sx={{ fontSize: 11, px: 1, borderRadius: 1, bgcolor: v.status==='pending'?'rgba(251,191,36,.15)':v.status==='approved'?'rgba(52,211,153,.15)':'rgba(248,113,113,.15)', color: v.status==='pending'?'#fbbf24':v.status==='approved'?'#34d399':'#f87171' }}>{v.status}</Typography>
                <Typography sx={{ color: '#475569', fontSize: 10, ml: 'auto' }}>{v.created_at ? new Date(v.created_at).toLocaleString('uk') : ''}</Typography>
              </Box>
              <Box sx={{ mt: 1 }}>
                <video controls style={{ width: '100%', maxHeight: 240, borderRadius: 8, background: '#000', display: 'block', marginBottom: 6 }}
                  src={'/media/' + v.video_path.replace('/app/static/', '')} />
                {v.status === 'approved' && v.extracted_face && <Typography sx={{ color: '#34d399', fontSize: 11 }}>✅ Обличчя та голос витягнуто</Typography>}
                {v.status === 'rejected' && v.reject_reason && <Typography sx={{ color: '#f87171', fontSize: 11 }}>❌ {v.reject_reason}</Typography>}
              </Box>
              <Box sx={{ display: 'flex', gap: 1, mt: 1, alignItems: 'center', flexWrap: 'wrap' }}>
                {v.status === 'pending' && <>
                  <Button size="small" sx={{ bgcolor: 'rgba(52,211,153,.15)', color: '#34d399', fontSize: 11, px: 1.5 }}
                    onClick={async () => { await API.post('/avatar/video-approve/'+v.id).catch(() => {}); loadStats(); }}>
                    ✅ Прийняти
                  </Button>
                  <TextField size="small" placeholder="Причина відхилення..." value={rejectReason[v.id]||''} onChange={e=>setRejectReason(r=>({...r,[v.id]:e.target.value}))}
                    sx={{ '& input': { fontSize: 11, py: 0.5, color: '#cbd5e1' }, '& fieldset': { borderColor: '#334155' }, width: 180 }} />
                  <Button size="small" sx={{ bgcolor: 'rgba(248,113,113,.15)', color: '#f87171', fontSize: 11, px: 1.5 }}
                    onClick={async () => { const fd = new FormData(); fd.append('reason', rejectReason[v.id]||''); await API.post('/avatar/video-reject/'+v.id, fd).catch(() => {}); loadStats(); }}>
                    ❌ Відхилити
                  </Button>
                </>}
                {v.status === 'approved' && (
                  <Button size="small" sx={{ bgcolor: 'rgba(251,191,36,.12)', color: '#fbbf24', fontSize: 11, px: 1.5 }}
                    onClick={async () => { await API.post('/avatar/video-approve/'+v.id).catch(() => {}); loadStats(); }}>
                    🔄 Повторити апрув
                  </Button>
                )}
                <Button size="small" sx={{ bgcolor: 'rgba(248,113,113,.1)', color: '#f87171', fontSize: 11, px: 1.5, ml: 'auto' }}
                  onClick={async () => { if (!window.confirm('Видалити відео?')) return; await API.delete('/avatar/video-delete/'+v.id).catch(() => {}); loadStats(); }}>
                  🗑 Видалити
                </Button>
              </Box>
            </Box>
          ))}
        </Paper>
      )}

      {/* ─── ВЕРИФІКАЦІЯ ОБЛИЧ (liveness-апрув) ─── */}
      <Paper sx={{ p: 3, bgcolor: '#1a1a2e', mb: 3, border: '1px solid ' + (vpend.length ? '#ff9800' : '#3a2a6e') }}>
        <Typography variant="h6" sx={{ color: '#ff9800', mb: 1 }}>🛡 Верифікація облич {vpend.length ? '(' + vpend.length + ' на розгляді)' : ''}</Typography>
        <Typography sx={{ color: '#aaa', fontSize: 13, mb: 2 }}>Юзер зняв відео-згоду. Переглянь, обери найкращий кадр обличчя й підтверди — тоді він зможе генерувати відео з цим обличчям і голосом.</Typography>
        {!vpend.length && <Typography sx={{ color: '#666', fontSize: 13 }}>Немає заявок на розгляді.</Typography>}
        {vpend.map(it => (
          <Box key={it.id} sx={{ border: '1px solid #333', borderRadius: 2, p: 2, mb: 2, bgcolor: '#12121f' }}>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', mb: 1, flexWrap: 'wrap' }}>
              <Typography sx={{ color: '#fff', fontWeight: 600 }}>{it.label}</Typography>
              <Typography sx={{ color: '#888', fontSize: 12 }}>tg:{it.tg_user_id} · {it.date}</Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'flex-start' }}>
              {it.video_url && <video src={it.video_url} controls playsInline style={{ width: 180, borderRadius: 8, background: '#000' }} />}
              <Box sx={{ flex: 1, minWidth: 220 }}>
                <Typography sx={{ color: '#aaa', fontSize: 12, mb: 0.5 }}>Обери кадр обличчя:</Typography>
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                  {(it.frames || []).map((f, fi) => (
                    <img key={fi} src={f} alt={'frame' + fi} onClick={() => setVsel(s => ({ ...s, [it.id]: fi }))}
                      style={{ width: 74, height: 98, objectFit: 'cover', borderRadius: 6, cursor: 'pointer', border: (vsel[it.id] || 0) === fi ? '3px solid #33e784' : '2px solid #444' }} />
                  ))}
                  {!(it.frames || []).length && <Typography sx={{ color: '#f66', fontSize: 12 }}>Кадри не витягнулись — перевір відео.</Typography>}
                </Box>
                {it.voice_url && <audio src={it.voice_url} controls style={{ width: '100%', height: 34, marginTop: 8 }} />}
              </Box>
            </Box>
            <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
              <Button variant="contained" disabled={vbusy === it.id} onClick={() => approveVerify(it.id)}
                sx={{ bgcolor: '#2e7d32', '&:hover': { bgcolor: '#1b5e20' } }}>✓ Підтвердити (кадр {(vsel[it.id] || 0) + 1})</Button>
              <Button variant="outlined" disabled={vbusy === it.id} onClick={() => rejectVerify(it.id)}
                sx={{ color: '#f66', borderColor: '#f66' }}>✕ Відхилити</Button>
            </Box>
          </Box>
        ))}
      </Paper>

      {/* ─── ВЛАСНЕ ФОТО ЮЗЕРА НА ПЕРЕВІРЦІ (звірити з відео — чи та сама людина) ─── */}
      {vcust.length > 0 && (
        <Paper sx={{ p: 3, bgcolor: '#1a1a2e', mb: 3, border: '1px solid #ff9800' }}>
          <Typography variant="h6" sx={{ color: '#ff9800', mb: 1 }}>📷 Власне фото на перевірці ({vcust.length})</Typography>
          <Typography sx={{ color: '#aaa', fontSize: 13, mb: 2 }}>Юзер надіслав своє фото (бо кадр із відео не сподобався). <b style={{ color: '#fff' }}>Звір із відео — чи це та сама людина.</b> Підтвердиш → це фото стане обличчям аватара.</Typography>
          {vcust.map(it => (
            <Box key={it.id} sx={{ border: '1px solid #333', borderRadius: 2, p: 2, mb: 2, bgcolor: '#12121f' }}>
              <Typography sx={{ color: '#fff', fontWeight: 600, mb: 1 }}>{it.label} <span style={{ color: '#888', fontSize: 12, fontWeight: 400 }}>tg:{it.tg_user_id}</span></Typography>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'flex-start' }}>
                {it.video_url && <Box sx={{ textAlign: 'center' }}><video src={it.video_url} controls playsInline style={{ width: 150, borderRadius: 8, background: '#000' }} /><Typography sx={{ color: '#888', fontSize: 11 }}>відео-верифікація</Typography></Box>}
                {it.custom_url && <Box sx={{ textAlign: 'center' }}><img src={it.custom_url} alt="custom" style={{ width: 130, borderRadius: 8, objectFit: 'cover', border: '2px solid #ff9800' }} /><Typography sx={{ color: '#ff9800', fontSize: 11 }}>надіслане фото</Typography></Box>}
                {it.current_face_url && <Box sx={{ textAlign: 'center' }}><img src={it.current_face_url} alt="cur" style={{ width: 90, height: 90, borderRadius: '50%', objectFit: 'cover', opacity: 0.7 }} /><Typography sx={{ color: '#888', fontSize: 11 }}>поточний кадр</Typography></Box>}
              </Box>
              <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
                <Button variant="contained" disabled={vbusy === it.id} onClick={() => custApprove(it.id)} sx={{ bgcolor: '#2e7d32', '&:hover': { bgcolor: '#1b5e20' } }}>✓ Та сама людина — зробити обличчям</Button>
                <Button variant="outlined" disabled={vbusy === it.id} onClick={() => custReject(it.id)} sx={{ color: '#f66', borderColor: '#f66' }}>✕ Відхилити фото</Button>
              </Box>
            </Box>
          ))}
        </Paper>
      )}

      {/* ─── АРХІВ ЗГОДИ (докази, що особа давала дозвіл) ─── */}
      <Paper sx={{ p: 3, bgcolor: '#1a1a2e', mb: 3, border: '1px solid #2a4a3e' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => setVapprOpen(o => !o)}>
          <Typography variant="h6" sx={{ color: '#33e784', flex: 1 }}>🗄 Архів згоди — верифіковані ({vappr.length})</Typography>
          <Typography sx={{ color: '#888', fontSize: 20 }}>{vapprOpen ? '▾' : '▸'}</Typography>
        </Box>
        <Typography sx={{ color: '#aaa', fontSize: 13, mt: 1, mb: vapprOpen ? 2 : 0 }}>Докази згоди: відео, де людина зачитує згоду, обране обличчя, дата підтвердження. Зберігай на випадок спорів.</Typography>
        {vapprOpen && !vappr.length && <Typography sx={{ color: '#666', fontSize: 13 }}>Ще немає підтверджених.</Typography>}
        {vapprOpen && vappr.map(it => (
          <Box key={it.id} sx={{ border: '1px solid #2a3a33', borderRadius: 2, p: 2, mb: 2, bgcolor: '#12121f', display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'flex-start' }}>
            {it.face_url && <img src={it.face_url} alt="face" style={{ width: 64, height: 64, borderRadius: '50%', objectFit: 'cover', border: '2px solid #33e784' }} />}
            <Box sx={{ minWidth: 200, flex: 1 }}>
              <Typography sx={{ color: '#fff', fontWeight: 600 }}>{it.label} <span style={{ color: '#33e784', fontSize: 12, fontWeight: 400 }}>✓ верифіковано</span></Typography>
              <Typography sx={{ color: '#888', fontSize: 12 }}>tg:{it.tg_user_id} · надіслано {it.created} · підтверджено {it.approved_at || '—'}</Typography>
              {it.voice_url && <audio src={it.voice_url} controls style={{ width: '100%', height: 32, marginTop: 6 }} />}
            </Box>
            {it.video_url && <video src={it.video_url} controls playsInline style={{ width: 150, borderRadius: 8, background: '#000' }} />}
            <Box sx={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
              <Button size="small" variant="outlined" onClick={() => deleteVerify(it.id, it.label)} sx={{ color: '#f66', borderColor: '#f66' }}>🗑 Видалити</Button>
            </Box>
          </Box>
        ))}
      </Paper>


      {/* ─── ЛОГОТИП ─── */}
      <Paper sx={{ p: 3, bgcolor: '#1a1a2e', mb: 3, border: '1px solid #3a2a6e' }}>
        <Typography variant="h6" sx={{ color: 'var(--ac1, #7c4dff)', mb: 2 }}>🖼️ Логотип</Typography>
        <Box sx={{ display: 'flex', gap: 3, alignItems: 'flex-start', flexWrap: 'wrap' }}>
          {/* Current logo */}
          <Box sx={{ textAlign: 'center' }}>
            <Typography sx={{ color: '#888', fontSize: 12, mb: 1 }}>Поточний</Typography>
            <Box sx={{ width: 80, height: 80, borderRadius: 2, overflow: 'hidden', border: '1px solid #333', bgcolor: '#0d0b18', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {logoUrl
                ? <img src={logoUrl} alt="logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                : <Typography sx={{ fontSize: 36 }}>🪞</Typography>}
            </Box>
            <Typography sx={{ color: '#555', fontSize: 10, mt: 0.5 }}>Hub Apps</Typography>
          </Box>

          {/* New logo preview */}
          {logoPreview && (
            <Box sx={{ textAlign: 'center' }}>
              <Typography sx={{ color: '#888', fontSize: 12, mb: 1 }}>Новий</Typography>
              <Box sx={{ width: 80, height: 80, borderRadius: 2, overflow: 'hidden', border: '1px solid var(--ac1, #7c4dff)', bgcolor: '#0d0b18', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <img src={logoPreview} alt="new logo" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
              </Box>
              <Typography sx={{ color: '#555', fontSize: 10, mt: 0.5 }}>{logoFile && logoFile.name}</Typography>
            </Box>
          )}

          {/* Upload controls */}
          <Box sx={{ flex: 1, minWidth: 220 }}>
            <input ref={logoInputRef} type="file" accept="image/jpeg,image/png,image/webp" style={{ display: 'none' }} onChange={onLogoFile} />
            <Box sx={{ display: 'flex', gap: 1, mb: 1 }}>
              <Button variant="outlined" onClick={() => logoInputRef.current && logoInputRef.current.click()} sx={{ color: '#fff', borderColor: '#555' }}>
                📁 Вибрати файл
              </Button>
              <Button variant="contained" onClick={saveLogo} disabled={logoBusy || !logoFile} sx={{ bgcolor: 'var(--ac1, #7c4dff)' }}>
                {logoBusy ? '⏳' : '💾 Зберегти'}
              </Button>
            </Box>
            <Typography sx={{ color: '#666', fontSize: 11 }}>JPG · PNG · WEBP</Typography>
            {logoMsg && <Alert severity={logoMsg.startsWith('❌') ? 'error' : 'success'} sx={{ mt: 1, py: 0 }}>{logoMsg}</Alert>}
          </Box>
        </Box>
      </Paper>

      <Paper sx={{ p: 3, bgcolor: '#1a1a2e', mb: 3 }}>
        <Typography variant="h6" sx={{ color: 'var(--ac1, #7c4dff)', mb: 1 }}>🎛️ Модель аватара</Typography>
        <TextField select fullWidth size="small" value={model} onChange={e => setModel(e.target.value)} sx={fieldSx}>
          {MODELS.map(m => <MenuItem key={m.key} value={m.key}>{m.label}</MenuItem>)}
        </TextField>
        <Typography sx={{ color: '#aaa', fontSize: 13, mt: 1 }}>{sel.note} · платформа: <b style={{ color: '#90caf9' }}>{sel.platform}</b></Typography>
      </Paper>

      <Paper sx={{ p: 3, bgcolor: '#1a1a2e', mb: 3 }}>
        <Typography variant="h6" sx={{ color: 'var(--ac1, #7c4dff)', mb: 2 }}>🔑 Токени платформ</Typography>
        <Typography sx={{ color: '#ccc', fontSize: 14, mb: 0.5 }}>Replicate <span style={{ color: '#888' }}>(p-video-avatar / SadTalker / OmniHuman)</span></Typography>
        {masked('replicate')
          ? <Alert severity="success" sx={{ mb: 1, bgcolor: 'rgba(76,175,80,0.1)', color: '#4caf50' }}>Збережено: {masked('replicate')}</Alert>
          : <Alert severity="warning" sx={{ mb: 1, bgcolor: 'rgba(255,152,0,0.1)', color: '#ff9800' }}>Ще не збережено. <a href="https://replicate.com/account/api-tokens" target="_blank" rel="noopener noreferrer" style={{ color: '#90caf9' }}>Створити токен</a></Alert>}
        <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
          <TextField fullWidth size="small" type="password" placeholder="Replicate API token" value={replicate} onChange={e => setReplicate(e.target.value)} sx={fieldSx}/>
          <Button variant="contained" onClick={() => saveKey('replicate', replicate, setReplicate)} sx={{ bgcolor: 'var(--ac1, #7c4dff)' }}>Зберегти</Button>
        </Box>
        <Typography sx={{ color: '#ccc', fontSize: 14, mb: 0.5 }}>WaveSpeed <span style={{ color: '#888' }}>(Hunyuan-Avatar)</span></Typography>
        {masked('wavespeed')
          ? <Alert severity="success" sx={{ mb: 1, bgcolor: 'rgba(76,175,80,0.1)', color: '#4caf50' }}>Збережено: {masked('wavespeed')}</Alert>
          : <Alert severity="warning" sx={{ mb: 1, bgcolor: 'rgba(255,152,0,0.1)', color: '#ff9800' }}>Ще не збережено. <a href="https://wavespeed.ai/accesskey" target="_blank" rel="noopener noreferrer" style={{ color: '#90caf9' }}>Створити токен</a></Alert>}
        <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
          <TextField fullWidth size="small" type="password" placeholder="WaveSpeed API token" value={wavespeed} onChange={e => setWavespeed(e.target.value)} sx={fieldSx}/>
          <Button variant="contained" onClick={() => saveKey('wavespeed', wavespeed, setWavespeed)} sx={{ bgcolor: 'var(--ac1, #7c4dff)' }}>Зберегти</Button>
        </Box>
        <Typography sx={{ color: '#ccc', fontSize: 14, mb: 0.5 }}>Hedra <span style={{ color: '#888' }}>(Character-3 · преміум talking-head)</span></Typography>
        {masked('hedra')
          ? <Alert severity="success" sx={{ mb: 1, bgcolor: 'rgba(76,175,80,0.1)', color: '#4caf50' }}>Збережено: {masked('hedra')}</Alert>
          : <Alert severity="warning" sx={{ mb: 1, bgcolor: 'rgba(255,152,0,0.1)', color: '#ff9800' }}>Ще не збережено. <a href="https://www.hedra.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#90caf9' }}>Створити ключ</a></Alert>}
        <Box sx={{ display: 'flex', gap: 1 }}>
          <TextField fullWidth size="small" type="password" placeholder="Hedra API key" value={hedra} onChange={e => setHedra(e.target.value)} sx={fieldSx}/>
          <Button variant="contained" onClick={() => saveKey('hedra', hedra, setHedra)} sx={{ bgcolor: 'var(--ac1, #7c4dff)' }}>Зберегти</Button>
        </Box>
      </Paper>

      <Paper sx={{ p: 3, bgcolor: '#1a1a2e', mb: 3 }}>
        <Typography variant="h6" sx={{ color: 'var(--ac1, #7c4dff)', mb: 1 }}>📷 Фото + 🎤 Аудіо → ▶️ Генерація</Typography>
        <Typography sx={{ color: '#888', fontSize: 12, mb: 2 }}>Дозволені формати — {FMT_TEXT}</Typography>
        <Box sx={{ display: 'flex', gap: 3, mb: 2, flexWrap: 'wrap', alignItems: 'flex-start' }}>
          <Box>
            <Button component="label" variant="outlined" sx={{ color: '#fff', borderColor: '#555' }}>
              {photo ? '📷 Змінити фото' : '📷 Вибрати фото'}
              <input hidden type="file" accept="image/jpeg,image/png,image/webp" onChange={onPhoto}/>
            </Button>
            {photoUrl && <Box sx={{ mt: 1 }}><img src={photoUrl} alt="прев'ю" style={{ maxWidth: 130, maxHeight: 130, borderRadius: 6, display: 'block', border: '1px solid #333' }}/><Typography sx={{ color: '#888', fontSize: 11 }}>{photo && photo.name}</Typography></Box>}
          </Box>
          <Box sx={{ minWidth: 280 }}>
            <Button component="label" variant="outlined" sx={{ color: '#fff', borderColor: '#555' }}>
              {audio ? '🎤 Змінити аудіо' : '🎤 Вибрати аудіо'}
              <input hidden type="file" accept="audio/*" onChange={onAudio}/>
            </Button>
            {audioUrl && <Box sx={{ mt: 1 }}><audio controls src={audioUrl} style={{ width: '100%' }}/><Typography sx={{ color: '#888', fontSize: 11 }}>{audio && audio.name}</Typography></Box>}
          </Box>
        </Box>
        <Button component="label" variant="outlined" sx={{ color: '#fff', borderColor: '#555', mb: 1, display: 'block', width: 'fit-content' }}>
          {inVideo ? ('🎬 ' + inVideo.name) : '🎬 АБО завантаж ВІДЕО (авто фото+аудіо)'}
          <input hidden type="file" accept="video/*" onChange={onVideo}/>
        </Button>
        {inVideoUrl && <Box sx={{ mb: 1 }}><video src={inVideoUrl} controls style={{ maxWidth: 200, borderRadius: 6 }}/></Box>}
        <Box sx={{ mb: 2 }}>
          <TextField select size="small" value={duration} onChange={e => setDuration(Number(e.target.value))} sx={{ ...fieldSx, minWidth: 200 }} label="Тривалість відео">
            {[[0, 'Повна (як аудіо)'], [5, '5 сек'], [10, '10 сек'], [15, '15 сек'], [30, '30 сек'], [60, '60 сек']].map(([v, n]) => <MenuItem key={v} value={v}>{n}</MenuItem>)}
          </TextField>
        </Box>
        <TextField fullWidth size="small" multiline minRows={2} value={text} onChange={e => setText(e.target.value)}
          placeholder="📝 ТЕКСТ, що казатиме аватар ТВОЇМ голосом (лиши пустим — візьме аудіо як є)" sx={{ ...fieldSx, mb: 1 }}/>
        {text.trim() && (
          <Box sx={{ mb: 2 }}>
            <FormControlLabel sx={{ display: 'block', color: '#ccc' }}
              control={<Checkbox checked={multilang} onChange={e => setMultilang(e.target.checked)} sx={{ color: 'var(--ac1, #7c4dff)' }}/>}
              label={<span style={{ fontSize: 13 }}>🌐 Мультимовний текст (різні мови в одному відео — авто-визначення)</span>}/>
            {!multilang && (
              <Box>
                <TextField select size="small" value={ttsLang} onChange={e => setTtsLang(e.target.value)} sx={{ ...fieldSx, minWidth: 200 }} label="Мова озвучки">
                  {[['uk', 'Українська'], ['ru', 'Російська'], ['en', 'English'], ['pl', 'Polski'], ['de', 'Deutsch'], ['es', 'Español'], ['it', 'Italiano'], ['pt', 'Português']].map(([c, n]) => <MenuItem key={c} value={c}>{n}</MenuItem>)}
                </TextField>
                <FormControlLabel sx={{ display: 'block', color: '#ccc', mt: 0.5 }}
                  control={<Checkbox checked={translate} onChange={e => setTranslate(e.target.checked)} sx={{ color: 'var(--ac1, #7c4dff)' }}/>}
                  label={<span style={{ fontSize: 13 }}>🌍 Перекласти мій текст на обрану мову</span>}/>
              </Box>
            )}
            {multilang && <Typography sx={{ color: '#90caf9', fontSize: 12, mt: 0.5 }}>Пиши мішаний текст — мови визначу автоматично й озвучу кожну частину своєю (твоїм голосом, по черзі).</Typography>}
            <Typography sx={{ color: '#ff9800', fontSize: 11, mt: 0.5 }}>🇺🇦 Українська тепер нативна (neon-tts) + конвертація у твій голос (free-vc). Аудіо вище = голос-семпл (≥6с).</Typography>
          </Box>
        )}
        <TextField fullWidth size="small" multiline minRows={1} value={prompt} onChange={e => setPrompt(e.target.value)}
          placeholder="Напрям/емоція (англ., опційно) — напр.: calm neutral expression, no smiling" sx={{ ...fieldSx, mb: 2 }}/>
        <Button variant="contained" disabled={busy} onClick={generate} sx={{ bgcolor: '#4caf50', fontWeight: 600 }}>
          {busy ? '⏳ Генерую…' : '▶️ Згенерувати відео'}
        </Button>
        {video && (
          <Box sx={{ mt: 2 }}>
            <video src={video} controls style={{ width: '100%', maxWidth: 360, borderRadius: 8 }}/>
            <Typography sx={{ mt: 0.5 }}><a href={video} target="_blank" rel="noopener noreferrer" style={{ color: '#90caf9' }}>⬇️ Завантажити відео</a></Typography>
          </Box>
        )}
      </Paper>

      {msg && <Alert severity={msg.startsWith('❌') ? 'error' : 'info'} sx={{ mb: 2 }}>{msg}</Alert>}

      <Paper sx={{ p: 2, bgcolor: '#16213e' }}>
        <Typography sx={{ color: '#888', fontSize: 12 }}>
          🔒 Токени замасковано. 🎭 Емоції точніше керуються на OmniHuman/Hunyuan (поле «напрям» — best-effort).
          🎤 ТЕКСТ→твій голос + 🌍 авто-переклад (один голос, багато мов) + 🎬 відео-вхід (авто фото+аудіо) + ⏱ тривалість.
        </Typography>
      </Paper>

      <Paper sx={{ p: 2, bgcolor: '#1a1a2e', border: '1px solid rgba(251,191,36,.25)', mt: 2 }}>
        <Typography sx={{ color: '#fbbf24', fontWeight: 600, mb: 1, fontSize: 14 }}>
          🎭 Настрої / Емоції (Hedra · Replicate)
        </Typography>
        <Typography sx={{ color: '#94a3b8', fontSize: 12, mb: 2 }}>
          Передає emotionPrompt до Hedra/Replicate при генерації аватара. Вмикай тільки коли готовий оплачувати надбавку — кожен рендер дорожчий.
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box sx={{ width: 48, height: 26, borderRadius: 13, bgcolor: emotionUi ? '#f59e0b' : '#374151',
            cursor: emotionBusy ? 'default' : 'pointer', position: 'relative', transition: 'background .2s', opacity: emotionBusy ? 0.6 : 1 }}
            onClick={async () => {
              if (emotionBusy) return;
              setEmotionBusy(true);
              try {
                const r = await API.put('/miniapp/avatar/config', null, { params: { emotion_ui: !emotionUi } });
                setEmotionUi(r.data.emotion_ui);
                setMsg(r.data.emotion_ui ? '✅ Настрої увімкнено' : '✅ Настрої вимкнено');
              } catch { setMsg('❌ Помилка збереження'); }
              finally { setEmotionBusy(false); }
            }}>
            <Box sx={{ position: 'absolute', top: 3, left: emotionUi ? 26 : 3, width: 20, height: 20, borderRadius: '50%', bgcolor: '#fff', transition: 'left .2s' }} />
          </Box>
          <Typography sx={{ color: emotionUi ? '#fbbf24' : '#64748b', fontSize: 13, fontWeight: 600 }}>
            {emotionUi ? '🟡 Увімкнено' : '⚫ Вимкнено'}
          </Typography>
        </Box>
      </Paper>

      <Paper sx={{ p: 2, bgcolor: '#1a1a2e', border: '1px solid var(--ac1, #7c4dff)33', mt: 2 }}>
        <Typography sx={{ color: '#b39ddb', fontWeight: 600, mb: 1, fontSize: 14 }}>
          📸 Скріншот для Claude
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Button variant="outlined" component="label" size="small"
            disabled={ccUploading}
            sx={{ borderColor: 'var(--ac1, #7c4dff)', color: '#b39ddb', whiteSpace: 'nowrap' }}>
            {ccUploading ? '⏳ Завантаження...' : '📁 Обрати файл'}
            <input type="file" accept="image/*" hidden onChange={uploadForClaude} />
          </Button>
          {ccFile && <Typography sx={{ color: '#888', fontSize: 12, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{ccFile}</Typography>}
        </Box>
        {ccPath && (
          <Box sx={{ mt: 1, p: 1, bgcolor: '#0d1117', borderRadius: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
            <Typography sx={{ color: '#58a6ff', fontSize: 11, fontFamily: 'monospace', flex: 1, wordBreak: 'break-all' }}>
              {ccPath}
            </Typography>
            <Button size="small" onClick={copyCcPath}
              sx={{ color: ccCopied ? '#4caf50' : '#b39ddb', minWidth: 0, p: '2px 8px', fontSize: 11 }}>
              {ccCopied ? '✅' : '📋'}
            </Button>
          </Box>
        )}
        {ccPath && !ccPath.startsWith('Помилка') && (
          <Typography sx={{ color: '#666', fontSize: 11, mt: 0.5 }}>
            Скажи Claude: <em style={{color:'#90caf9'}}>прочитай {ccPath}</em>
          </Typography>
        )}
      </Paper>

      {/* AVA User Limits */}
      <Paper sx={{ p: 2, bgcolor: '#1a1a2e', border: '1px solid rgba(100,200,255,.2)', mt: 2 }}>
        <Typography sx={{ color: '#7dd3fc', fontWeight: 600, mb: 1.5, fontSize: 14 }}>
          👥 Ліміти юзерів AVA
        </Typography>
        <Typography sx={{ color: '#64748b', fontSize: 11, mb: 1.5 }}>
          Дефолти: фото ≤ {limDefaults.max_img_mb} MB · аудіо ≤ {limDefaults.max_aud_mb} MB · відео ≤ {limDefaults.max_vid_mb} MB
        </Typography>

        {/* Add new user */}
        <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
          <TextField size="small" label="Telegram ID" type="number" value={newTgId}
            onChange={e => setNewTgId(e.target.value)}
            sx={{ width: 160, input: { color: '#e2e8f0' }, label: { color: '#64748b' }, '& .MuiOutlinedInput-root fieldset': { borderColor: '#334155' } }} />
          <Button size="small" variant="outlined" sx={{ borderColor: '#38bdf8', color: '#38bdf8' }}
            disabled={!newTgId}
            onClick={() => {
              const tid = parseInt(newTgId);
              if (!tid) return;
              setLimEdit({ tg_id: tid, username: '', max_img_mb: limDefaults.max_img_mb, max_aud_mb: limDefaults.max_aud_mb, max_vid_mb: limDefaults.max_vid_mb, daily_gen_limit: '', note: '' });
              setNewTgId('');
            }}>
            + Додати юзера
          </Button>
        </Box>

        {/* Edit form */}
        {limEdit && (
          <Box sx={{ p: 1.5, mb: 2, border: '1px solid #334155', borderRadius: 1.5, bgcolor: 'rgba(0,0,0,.2)' }}>
            <Typography sx={{ color: '#e2e8f0', fontSize: 12, mb: 1 }}>
              Редагувати: tg_id {limEdit.tg_id}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 1 }}>
              {[["username","Username/Note","text",120],["max_img_mb","Фото MB","number",90],["max_aud_mb","Аудіо MB","number",90],["max_vid_mb","Відео MB","number",90],["daily_gen_limit","Ген/день (∞=порожньо)","number",110],["video_retention_hours","Зберігання відео (год)","number",130]].map(([field,label,type,w]) => (
                <TextField key={field} size="small" label={label} type={type} value={limEdit[field] ?? ''}
                  onChange={e => setLimEdit(p => ({...p, [field]: e.target.value || (type==='number' ? '' : '') }))}
                  sx={{ width: w, input: { color: '#e2e8f0' }, label: { color: '#64748b' }, '& .MuiOutlinedInput-root fieldset': { borderColor: '#334155' } }} />
              ))}
            </Box>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button size="small" variant="contained" sx={{ bgcolor: '#0284c7' }}
                onClick={async () => {
                  setLimMsg(null);
                  try {
                    await API.put(`/miniapp/avatar/user-limits/${limEdit.tg_id}`, {
                      username: limEdit.username || '',
                      max_img_mb: parseInt(limEdit.max_img_mb) || limDefaults.max_img_mb,
                      max_aud_mb: parseInt(limEdit.max_aud_mb) || limDefaults.max_aud_mb,
                      max_vid_mb: parseInt(limEdit.max_vid_mb) || limDefaults.max_vid_mb,
                      daily_gen_limit: limEdit.daily_gen_limit ? parseInt(limEdit.daily_gen_limit) : null,
                      note: limEdit.note || '',
                      video_retention_hours: parseInt(limEdit.video_retention_hours) || 48,
                    });
                    setLimEdit(null); loadLimits();
                    setLimMsg({ type: 'success', text: 'Збережено' });
                  } catch(e) { setLimMsg({ type: 'error', text: e.message }); }
                }}>
                ✓ Зберегти
              </Button>
              <Button size="small" sx={{ color: '#64748b' }} onClick={() => setLimEdit(null)}>Скасувати</Button>
            </Box>
          </Box>
        )}

        {limMsg && <Alert severity={limMsg.type} sx={{ mb: 1, fontSize: 12 }}>{limMsg.text}</Alert>}

        {/* Users list */}
        {limUsers.length === 0 ? (
          <Typography sx={{ color: '#475569', fontSize: 12 }}>Немає кастомних лімітів — всі юзери на дефолтах.</Typography>
        ) : (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
            {limUsers.map(u => (
              <Box key={u.tg_id} sx={{ display: 'flex', alignItems: 'center', gap: 1, p: '6px 10px', borderRadius: 1, bgcolor: 'rgba(255,255,255,.03)', flexWrap: 'wrap' }}>
                <Typography sx={{ color: '#94a3b8', fontSize: 12, minWidth: 80, fontFamily: 'monospace' }}>{u.tg_id}</Typography>
                <Typography sx={{ color: '#cbd5e1', fontSize: 12, minWidth: 80 }}>{u.username || '—'}</Typography>
                {(() => { const rev = userRevenues.find(r => r.tg_id === u.tg_id); return rev ? (
                  <Typography sx={{ color: '#34d399', fontSize: 11, fontWeight: 700, minWidth: 60 }}>${rev.total_revenue.toFixed(2)} <span style={{color:'#64748b',fontWeight:400}}>({rev.gen_count} ген)</span></Typography>
                ) : null; })()}
                <Typography sx={{ color: '#7dd3fc', fontSize: 11 }}>
                  🖼 {u.max_img_mb}MB · 🎙 {u.max_aud_mb}MB · 🎥 {u.max_vid_mb}MB
                  {u.daily_gen_limit ? ` · ⚡ ${u.daily_gen_limit}/d` : ''}
                  {u.video_retention_hours && u.video_retention_hours !== 48 ? ` · 🕐 ${u.video_retention_hours}г` : ''}
                </Typography>
                <Box sx={{ display: 'flex', gap: 0.5, ml: 'auto' }}>
                  <Button size="small" sx={{ color: '#fbbf24', fontSize: 11, minWidth: 0, p: '1px 8px' }}
                    onClick={() => setLimEdit({...u, daily_gen_limit: u.daily_gen_limit ?? '', video_retention_hours: u.video_retention_hours ?? 48 })}>✏️</Button>
                  <Button size="small" sx={{ color: '#f87171', fontSize: 11, minWidth: 0, p: '1px 8px' }}
                    onClick={async () => {
                      await API.delete(`/miniapp/avatar/user-limits/${u.tg_id}`);
                      loadLimits();
    loadHubMusic();
                    }}>🗑</Button>
                </Box>
              </Box>
            ))}
          </Box>
        )}
      </Paper>

      {/* [D-298] Модельний радар — live-пошук новинок генерації з цінами і порівнянням */}
      <Paper sx={{ p: 2, bgcolor: '#1a1a2e', border: '1px solid rgba(52,211,153,.3)', mt: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', mb: 1 }}>
          <Typography sx={{ color: '#34d399', fontWeight: 'bold' }}>🛰 Модельний радар</Typography>
          <Button size="small" variant="outlined" onClick={startRadar} disabled={radarRunning}
            sx={{ color: '#34d399', borderColor: '#34d399', fontSize: 12 }}>
            {radarRunning ? '⏳ Сканую… (1-2 хв)' : '🔍 Сканувати новинки'}
          </Button>
          {radarAt && <Typography sx={{ color: '#777', fontSize: 11 }}>останній скан: {radarAt}</Typography>}
          <Typography sx={{ color: '#555', fontSize: 10.5 }}>~$0.1/скан · web-пошук через Claude</Typography>
        </Box>
        {radarMsg && <Alert severity="warning" sx={{ mb: 1, py: 0 }}>{radarMsg}</Alert>}
        {radar?.error && (
          <Alert severity="error" sx={{ mb: 1 }}>Скан не вдався: {radar.error}</Alert>
        )}
        {radar && !radar.error && (
          <Box>
            {radar._no_web_search && <Alert severity="info" sx={{ mb: 1, py: 0 }}>⚠️ web-пошук був недоступний — дані зі знань моделі, можуть бути не найсвіжіші</Alert>}
            <Box sx={{ bgcolor: 'rgba(52,211,153,.08)', border: '1px solid rgba(52,211,153,.25)', borderRadius: 1, p: 1.2, mb: 1.5 }}>
              <Typography sx={{ color: '#d1fae5', fontSize: 13 }}>{radar.summary}</Typography>
            </Box>
            {(radar.recommendations || []).length > 0 && (
              <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 1.5 }}>
                {radar.recommendations.map((r, i) => (
                  <Box key={i} sx={{ bgcolor: 'rgba(251,191,36,.09)', border: '1px solid rgba(251,191,36,.3)', borderRadius: 1, p: 1, minWidth: 180, flex: '1 1 200px' }}>
                    <Typography sx={{ color: '#fbbf24', fontSize: 11, fontWeight: 'bold' }}>{({ avatar: '\u{1F3AD} Аватар', video: '\u{1F3AC} Відео', voice: '\u{1F399} Голос' })[r.category] || r.category}</Typography>
                    <Typography sx={{ color: '#fff', fontSize: 13, fontWeight: 'bold' }}>{r.pick}</Typography>
                    <Typography sx={{ color: '#aaa', fontSize: 11 }}>{r.why}</Typography>
                  </Box>
                ))}
              </Box>
            )}
            {/* базлайни нашого стеку для контексту */}
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 1 }}>
              {[['\u{1F3AD} наш avatar', '$3.00/2хв', 'p-video-avatar'], ['\u{1F3AD} наш преміум', '$4.00/2хв', 'Hedra'], ['\u{1F399} наш voice', '$0.05/2хв', 'XTTS+FreeVC']].map(([t, p, n], i) => (
                <Box key={i} sx={{ bgcolor: 'rgba(125,211,252,.08)', border: '1px dashed rgba(125,211,252,.4)', borderRadius: 1, px: 1, py: 0.4 }}>
                  <Typography sx={{ fontSize: 11, color: '#7dd3fc' }}>{t}: <b>{p}</b> <span style={{ color: '#667' }}>({n})</span></Typography>
                </Box>
              ))}
            </Box>
            {(() => {
              const CATS = { avatar: '\u{1F3AD}', video: '\u{1F3AC}', voice: '\u{1F399}' };
              const BASE = { avatar: 3.0, video: null, voice: 0.05 };
              const rows = [...(radar.models || [])].sort((a, b) => {
                const pa = typeof a.price_2min_usd === 'number' ? a.price_2min_usd : 1e9;
                const pb = typeof b.price_2min_usd === 'number' ? b.price_2min_usd : 1e9;
                return pa - pb;
              });
              const vColor = { cheaper: '#34d399', similar: '#fbbf24', pricier: '#f87171' };
              const hCell = { color: 'var(--ac1, #7c4dff)', fontWeight: 'bold', fontSize: 11.5, borderBottom: '1px solid #333', py: 0.6, px: 1 };
              const cell = { borderBottom: '1px solid #23233a', py: 0.7, px: 1, verticalAlign: 'top' };
              return (
                <Box component="table" sx={{ width: '100%', borderCollapse: 'collapse' }}>
                  <Box component="thead"><Box component="tr">
                    {['Модель', 'Кат.', '\u{1F4B0} ~$/2хв', 'Тариф', '\u2B50 Якість', 'vs наш стек', 'Реліз'].map(h => (
                      <Box component="th" key={h} sx={{ ...hCell, textAlign: 'left' }}>{h}</Box>
                    ))}
                  </Box></Box>
                  <Box component="tbody">
                    {rows.map((m, i) => {
                      const p = typeof m.price_2min_usd === 'number' ? m.price_2min_usd : null;
                      const base = BASE[m.category];
                      const diff = (p != null && base != null) ? p - base : null;
                      return (
                        <Box component="tr" key={i} sx={{ '&:hover': { bgcolor: 'rgba(var(--ac1rgb, 124, 77, 255),.06)' } }}>
                          <Box component="td" sx={cell}>
                            <Typography sx={{ fontSize: 12.5, fontWeight: 'bold' }}>
                              {m.url ? <a href={m.url} target="_blank" rel="noreferrer" style={{ color: '#7dd3fc', textDecoration: 'none' }}>{m.name}</a> : <span style={{ color: '#fff' }}>{m.name}</span>}
                              {m.unverified && <span title="URL не знайдено — дані можуть бути неточні" style={{ marginLeft: 4, fontSize: 10, color: '#f87171', background: 'rgba(248,113,113,0.12)', borderRadius: 3, padding: '1px 4px' }}>⚠️ не верифіковано</span>}
                            </Typography>
                            <Typography sx={{ color: '#778', fontSize: 10.5 }}>{m.provider}{m.api ? ` · ${m.api}` : ''}</Typography>
                          </Box>
                          <Box component="td" sx={{ ...cell, fontSize: 15 }}>{CATS[m.category] || m.category}</Box>
                          <Box component="td" sx={cell}>
                            <Typography sx={{ fontSize: 13, fontWeight: 'bold', color: vColor[m.verdict] || '#ddd' }}>
                              {p != null ? `${m.approx ? '~' : ''}$${p.toFixed(2)}` : '?'}
                            </Typography>
                            {diff != null && <Typography sx={{ fontSize: 10, color: diff < 0 ? '#34d399' : '#f87171' }}>{diff < 0 ? `економія $${(-diff).toFixed(2)}` : `+$${diff.toFixed(2)}`}</Typography>}
                          </Box>
                          <Box component="td" sx={{ ...cell, color: '#aab', fontSize: 11 }}>{m.price_detail || ''}</Box>
                          <Box component="td" sx={{ ...cell, color: '#fbbf24', fontSize: 12, whiteSpace: 'nowrap' }}>{m.quality ? '\u2605'.repeat(Math.min(5, m.quality)) + '\u2606'.repeat(Math.max(0, 5 - m.quality)) : ''}</Box>
                          <Box component="td" sx={{ ...cell, fontSize: 11 }}>
                            {m.verdict && <span style={{ color: vColor[m.verdict] || '#ddd', fontWeight: 'bold' }}>{({ cheaper: '\u2193 дешевше', similar: '\u2248 схоже', pricier: '\u2191 дорожче' })[m.verdict] || m.verdict}</span>}
                            <Typography sx={{ color: 'var(--ac2, #a78bfa)', fontSize: 10.5 }}>{m.vs_current}</Typography>
                            <Typography sx={{ color: '#889', fontSize: 10.5 }}>{m.strengths}</Typography>
                          </Box>
                          <Box component="td" sx={{ ...cell, color: '#889', fontSize: 11, whiteSpace: 'nowrap' }}>{m.released || ''}</Box>
                        </Box>
                      );
                    })}
                  </Box>
                </Box>
              );
            })()}
            {radar._usage && <Typography sx={{ color: '#555', fontSize: 10, mt: 1 }}>tokens: in {radar._usage.input_tokens} / out {radar._usage.output_tokens} · {radar._model}</Typography>}
          </Box>
        )}
        {!radar && !radarRunning && <Typography sx={{ color: '#777', fontSize: 12 }}>Ще не сканувалось. Натисни «Сканувати новинки» — Claude знайде найновіші моделі (аватар/відео/голос) з цінами і порівняє з нашим стеком.</Typography>}
      </Paper>

      {/* [AVA-PRICING] Управління цінами */}
      <Paper sx={{ p: 2.5, bgcolor: '#0d1117', border: '1px solid rgba(165,243,252,.25)', mt: 2, borderRadius: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', mb: 2.5 }}>
          <Typography sx={{ color: '#a5f3fc', fontWeight: 800, fontSize: 15 }}>💰 Тарифні плани AVA</Typography>
          <Typography sx={{ color: '#475569', fontSize: 11 }}>$ за 10 секунд → решта розраховується автоматично</Typography>
          {pricingMsg && <Typography sx={{ fontSize: 12, color: pricingMsg.startsWith('✅') ? '#34d399' : '#f87171', ml: 'auto' }}>{pricingMsg}</Typography>}
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          {pricing.map(tier => {
            const isComing = tier.status === 'coming_soon';
            const price = parseFloat(pricingEdit[tier.quality_key + '_price'] ?? tier.price_per_10s);
            const cost = parseFloat(pricingEdit[tier.quality_key + '_cost'] ?? tier.cost_per_10s);
            const margin = isNaN(price) || isNaN(cost) ? 0 : price - cost;
            const pct = isNaN(price) || !price ? 0 : Math.round(margin / price * 100);
            return (
              <Box key={tier.quality_key} sx={{ p: 2, borderRadius: 1.5, bgcolor: isComing ? 'rgba(255,255,255,.02)' : 'rgba(255,255,255,.04)', border: '1px solid', borderColor: isComing ? '#1e293b' : 'rgba(165,243,252,.15)', opacity: isComing ? 0.7 : 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: isComing ? 0 : 1.5, flexWrap: 'wrap' }}>
                  <Typography sx={{ fontSize: 20, lineHeight: 1 }}>{tier.tier_emoji || '▶'}</Typography>
                  <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: 15 }}>{tier.quality_label}</Typography>
                  {isComing
                    ? <Typography sx={{ fontSize: 10, px: 1, py: '2px', borderRadius: 1, bgcolor: 'rgba(251,191,36,.15)', color: '#fbbf24', fontWeight: 600 }}>⏳ Скоро</Typography>
                    : <Typography sx={{ fontSize: 10, px: 1, py: '2px', borderRadius: 1, bgcolor: 'rgba(52,211,153,.12)', color: '#34d399', fontWeight: 600 }}>✅ Активна</Typography>}
                  <Typography sx={{ color: '#334155', fontSize: 11, fontFamily: 'monospace' }}>{tier.model_key}</Typography>
                  {!isComing && <Typography sx={{ color: '#fbbf24', fontSize: 11, ml: 'auto', fontWeight: 700 }}>маржа {pct}% (+${margin.toFixed(2)}/10с)</Typography>}
                </Box>
                {!isComing && (<>
                  <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'flex-end', mb: 1.5 }}>
                    <Box>
                      <Typography sx={{ color: '#a5f3fc', fontSize: 10, mb: 0.5, textTransform: 'uppercase', letterSpacing: .5 }}>Ціна юзеру / 10с</Typography>
                      <TextField size="small" type="number" inputProps={{ step: '0.01', min: '0' }}
                        value={pricingEdit[tier.quality_key + '_price'] ?? tier.price_per_10s}
                        onChange={e => setPricingEdit(s => ({ ...s, [tier.quality_key + '_price']: e.target.value }))}
                        sx={{ width: 120, '& input': { color: '#a5f3fc', fontWeight: 700, fontSize: 15 }, '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(165,243,252,.35)' } }} />
                    </Box>
                    <Box>
                      <Typography sx={{ color: '#fbbf24', fontSize: 10, mb: 0.5, textTransform: 'uppercase', letterSpacing: .5 }}>Собівартість / 10с</Typography>
                      <TextField size="small" type="number" inputProps={{ step: '0.01', min: '0' }}
                        value={pricingEdit[tier.quality_key + '_cost'] ?? tier.cost_per_10s}
                        onChange={e => setPricingEdit(s => ({ ...s, [tier.quality_key + '_cost']: e.target.value }))}
                        sx={{ width: 120, '& input': { color: '#fbbf24', fontWeight: 700, fontSize: 15 }, '& .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(251,191,36,.3)' } }} />
                    </Box>
                    <Button size="small" disabled={pricingSaving[tier.quality_key]} onClick={() => saveTier(tier)}
                      sx={{ bgcolor: 'rgba(var(--ac1rgb, 124, 77, 255),.25)', border: '1px solid rgba(var(--ac1rgb, 124, 77, 255),.5)', color: '#c4b5fd', fontWeight: 700, height: 40, px: 2, '&:hover': { bgcolor: 'rgba(var(--ac1rgb, 124, 77, 255),.4)' } }}>
                      {pricingSaving[tier.quality_key] ? '…' : '💾'}
                    </Button>
                  </Box>
                  <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    {DURATIONS.map(s => (
                      <Box key={s} sx={{ px: 1.5, py: 0.8, borderRadius: 1.5, bgcolor: 'rgba(165,243,252,.05)', border: '1px solid rgba(165,243,252,.1)', textAlign: 'center', minWidth: 64 }}>
                        <Typography sx={{ color: '#475569', fontSize: 9, textTransform: 'uppercase' }}>{s}с</Typography>
                        <Typography sx={{ color: '#a5f3fc', fontWeight: 700, fontSize: 13 }}>${(price * s / 10).toFixed(2)}</Typography>
                        <Typography sx={{ color: '#fbbf24', fontSize: 9 }}>-${(cost * s / 10).toFixed(2)}</Typography>
                      </Box>
                    ))}
                  </Box>
                </>)}
              </Box>
            );
          })}
        </Box>
      </Paper>

      {/* [D-301] Фонова музика Хаба (WheelHome) */}}
      <Paper sx={{ p: 2, bgcolor: '#1a1a2e', border: '1px solid rgba(52,211,153,.28)', mt: 2 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap', mb: 1 }}>
          <Typography sx={{ color: '#34d399', fontWeight: 'bold' }}>🎵 Фонова музика Хаба</Typography>
          <Button size="small" variant="outlined" disabled={musicUploading} onClick={() => musicInputRef.current && musicInputRef.current.click()}
            sx={{ color: '#34d399', borderColor: '#34d399', fontSize: 12 }}>
            {musicUploading ? '⏳ Завантаження…' : '⬆ Додати трек'}
          </Button>
          <input ref={musicInputRef} type="file" accept="audio/*,.mp3,.ogg,.m4a,.aac,.wav" style={{ display: 'none' }} onChange={uploadHubMusic} />
          <Typography sx={{ color: '#667', fontSize: 11 }}>рандомний трек при вході · тільки Хаб-колесо · макс 12MB</Typography>
        </Box>
        {hubMusic.length === 0 && <Typography sx={{ color: '#777', fontSize: 12 }}>Ще немає треків. Додай кілька — вмикатимуться рандомно щоразу.</Typography>}
        {hubMusic.map(tr => (
          <Box key={tr.id} sx={{ display: 'flex', alignItems: 'center', gap: 1, borderBottom: '1px solid #26263e', py: 0.7 }}>
            <span style={{ fontSize: 16 }}>{tr.enabled ? '🎶' : '🔇'}</span>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <Typography sx={{ color: '#fff', fontSize: 13, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{tr.original_name || tr.filename}</Typography>
              <audio src={tr.url} controls preload="none" style={{ height: 28, width: '100%', maxWidth: 260 }} />
            </Box>
            <Button size="small" onClick={() => toggleHubMusic(tr.id)} sx={{ color: tr.enabled ? '#34d399' : '#888', fontSize: 11, minWidth: 0 }}>{tr.enabled ? 'вкл' : 'викл'}</Button>
            <Button size="small" onClick={() => deleteHubMusic(tr.id)} sx={{ color: '#f87171', fontSize: 11, minWidth: 0 }}>🗑</Button>
          </Box>
        ))}
      </Paper>

      {/* 🎁 подарунок балансу Аватара */}
      <Dialog open={!!avaGift} onClose={() => setAvaGift(null)} maxWidth="xs" fullWidth
        PaperProps={{ sx: { bgcolor: '#0d1117', border: '1px solid rgba(251,191,36,.4)' } }}>
        <DialogTitle sx={{ color: '#e2e8f0' }}>
          🎁 Подарунок балансу — {avaGift?.username || avaGift?.tg_id}
        </DialogTitle>
        <DialogContent>
          <Typography sx={{ color: '#94a3b8', fontSize: 12, mb: 1 }}>
            Баланс зараз: <b>${Number(avaGift?.balance_usdt || 0).toFixed(2)}</b> · від'ємна сума = тиха корекція
          </Typography>
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
            {[1, 3, 5, 10].map(n => (
              <Chip key={n} label={'+$' + n} size="small" clickable onClick={() => setAvaGiftAmt(String(n))}
                sx={{ bgcolor: String(n) === String(avaGiftAmt) ? 'rgba(251,191,36,.3)' : 'rgba(255,255,255,.06)',
                      color: String(n) === String(avaGiftAmt) ? '#fbbf24' : '#94a3b8' }} />
            ))}
            <TextField size="small" type="number" value={avaGiftAmt} onChange={e => setAvaGiftAmt(e.target.value)}
              inputProps={{ step: '0.5', style: { color: '#e2e8f0', width: 76, padding: '6px 8px' } }} />
          </Box>
          <FormControlLabel sx={{ mt: .5, ml: 0 }}
            control={<Switch size="small" checked={avaGiftNotify} onChange={e => setAvaGiftNotify(e.target.checked)} color="warning" />}
            label={<Typography sx={{ color: '#94a3b8', fontSize: 12 }}>🎉 святкове вітання у бот</Typography>} />
          {avaGiftMsg && <Typography sx={{ fontSize: 13, mt: .5, color: avaGiftMsg.startsWith('✅') ? '#34d399' : (avaGiftMsg === '…' ? '#64748b' : '#f87171') }}>{avaGiftMsg}</Typography>}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setAvaGift(null)} sx={{ color: '#64748b' }}>Закрити</Button>
          <Button variant="contained" disabled={avaGiftBusy} onClick={avaGiftGo}
            sx={{ bgcolor: '#fbbf24', color: '#0d1117', fontWeight: 700 }}>{avaGiftBusy ? '…' : '🎁 Подарувати'}</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
